<template>
  <div>
    <vl-map
      class="map"
      ref="map"
      @created="mapCreated"
      data-projection="EPSG:4326"
      :controls="false"
      :move-tolerance="200"
    >
      <vl-view
        :zoom.sync="zoom"
        :center.sync="center"
      >
      </vl-view>
      <vl-layer-tile id="osm">
        <vl-source-osm></vl-source-osm>
      </vl-layer-tile>
      <div
        v-for="municipio in municipiosFiltereds"
        v-bind:key="municipio.id"
      >
        <div>
          <vl-feature>
            <vl-geom-point
              :coordinates="[municipio.longitude, municipio.latitude]"
            ></vl-geom-point>
            <vl-style-box>
              <vl-style-icon
                src="https://cdn4.iconfinder.com/data/icons/small-n-flat/24/map-marker-128.png"
                :scale="markerScale"
              ></vl-style-icon>
            </vl-style-box>
          </vl-feature>
        </div>
      </div>
    </vl-map>
    <PanelLocation></PanelLocation>
  </div>
</template>

<script>
import PanelLocation from './PanelLocations'
import { mapGetters } from "vuex"

export default {
  name: 'Mapa',
  components: { PanelLocation },
  data() {
    return {
      zoom: 6,
      center: [-41, -4],
      markerScale: 0.1
    };
  },
  computed: {
    ...mapGetters(['municipiosFiltereds'])
  },
  watch: {
    zoom: function(value) {
      if (value > 4) {
        this.markerScale = 0.1
      }
      if (value > 6) {
        this.markerScale = 0.2
      }
    }
  },
  methods: {
    mapCreated () {
      this.$refs.map.$map.getInteractions().clear()
    },
  }
};
</script>

<style>

  .map {
    height: 671px !important;
  }

</style>
